export enum FieldsOfRelevanceEnum {
  wire = 'wire',
  cables = 'cables',
  flatProducts = 'flat-products',
  longProducts = 'long-products',
  ropes = 'ropes',
  fasteners = 'fasteners',
  springs = 'springs',
  tubes = 'tubes',
  profiles = 'profiles',
  sheetMetal = 'sheet-metal',
  smallMetalParts = 'small-metal-parts'
}
